import type { CarRouteResponse, Route } from '@/js/types/map.ts';
import { load } from '@2gis/mapgl';
import { makeRequest } from '@/js/api/request-service.ts';
import { ref } from 'vue';

const API_KEY = '19a062a8-729e-47dd-a9b0-f91766e4678a';
const ROUTING_API_URL = `https://routing.api.2gis.com/routing/7.0.0/global?key=${API_KEY}`;
type Point = {
  lon: number
  lat: number
};
export function useMapgl() {
  const isLoaded = ref(false);

  async function loadAPI() {
    await load();
    isLoaded.value = true;
  }

  function createMap(selector: string, options: mapgl.MapOptions) {
    // eslint-disable-next-line ts/no-unsafe-return,ts/no-unsafe-call,ts/no-unsafe-member-access
    return new mapgl.Map(selector, { ...options, key: API_KEY });
  }

  function createMarker(map: mapgl.Map, coordinates: number[]) {
    // eslint-disable-next-line ts/no-unsafe-return,ts/no-unsafe-call,ts/no-unsafe-member-access
    return new mapgl.Marker(map, {
      coordinates,
    });
  }

  function createLine(map: mapgl.Map, coordinates: number[][]) {
    // eslint-disable-next-line ts/no-unsafe-return,ts/no-unsafe-call,ts/no-unsafe-member-access
    return new mapgl.Polyline(map, {
      coordinates,
      color: '#3962b2',
    });
  }
  async function getCarRoute(start: Point, end: Point) {
    return makeRequest<CarRouteResponse>({
      method: 'POST',
      url: ROUTING_API_URL,
      data: {
        points: [
          { type: 'stop', lon: start.lon, lat: start.lat },
          { type: 'stop', lon: end.lon, lat: end.lat },
        ],
        locale: 'ru',
        transport: 'driving',
        route_mode: 'fastest',
        traffic_mode: 'jam',
      },
    });
  }

  function parseLineString(selection: string) {
    const coordsString = selection.replace('LINESTRING(', '').replace(')', '');
    return coordsString.split(',').map((point) => {
      const [lon, lat] = point.trim().split(' ').map(Number);
      return [lon, lat];
    });
  }

  function getRouteCoordinates(routeResult: Route) {
    const coordinates: number[][] = [];

    routeResult.maneuvers.forEach((maneuver) => {
      // eslint-disable-next-line ts/no-unnecessary-condition,ts/strict-boolean-expressions
      if (maneuver.outcoming_path && maneuver.outcoming_path.geometry) {
        maneuver.outcoming_path.geometry.forEach((geo) => {
          coordinates.push(...parseLineString(geo.selection));
        });
      }
    });

    return coordinates;
  }

  function createLineByRoute(map: mapgl.Map, route: Route) {
    const coordinates = getRouteCoordinates(route);
    // eslint-disable-next-line ts/no-unsafe-return
    return createLine(map, coordinates);
  }

  return {
    loadAPI,
    isLoaded,

    createMap,
    createMarker,
    createLine,
    createLineByRoute,

    getCarRoute,
  };
}
